const formatMoney = (price: number): string => Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format(price / 100);

export default formatMoney;
